export const LIKE_VIDEO = `
  mutation likeVideo($id: ID!) {
    likeVideo(id: $id)
  }
`;

export const UNLIKE_VIDEO = `
  mutation unLikeVideo($id: ID!) {
    unLikeVideo(id: $id)
  }
`;

export const LIKE_COMMENT = `
  mutation likeComment($id: ID!) {
    likeComment(id: $id)
  }
`;

export const UNLIKE_COMMENT = `
  mutation unLikeComment($id: ID!) {
    unLikeComment(id: $id)
  }
`;
